import * as React from 'react'
import { useNavigate } from 'react-router-dom'

import { EditCustomTablePageDocument } from 'generated/resources/graphql'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useQuery } from 'modules/core/hooks/useQuery'
import { useStrictParams } from 'modules/core/hooks/useStrictParams'

import resources from 'modules/custom_resources/store/collections/customResources/resources'
import FormModal from 'modules/employees/components/CustomTables/FormModal'
import { RouteContext } from 'modules/employees/pages/CustomTablesListPage/context'

export default function EditCustomTablePage() {
  const { id: employeeIdparam, schemaId } = useStrictParams<'id' | 'schemaId'>()
  const navigate = useNavigate()
  const { employee: sessionEmployee } = useCurrentSession()

  const employeeId = employeeIdparam ? Number(employeeIdparam) : sessionEmployee.id

  const { data } = useQuery(EditCustomTablePageDocument, {
    variables: {
      employeeId: employeeId,
      schemaId: Number(schemaId),
    },
    skip: !schemaId,
  })

  const schema = data?.customResources.schema
  const currency = data?.employees.employee?.legalEntity?.currency ?? ''
  const canRemoveCustomTableRecords =
    data?.employees?._policies?.removeCustomTableRecords?.can ?? false

  const rootRoute = React.useContext(RouteContext)

  if (!schema) return null

  const resource = resources.find({
    schema_id: schema.id,
    attachable_type: 'Employee',
    attachable_id: employeeId,
  })

  const onClose = () => {
    !!rootRoute && navigate(rootRoute.customTablesIndex())
  }

  if (!resource) return null

  return (
    <FormModal
      schema={schema}
      resource={resource}
      attachableId={employeeId}
      attachableType="Employee"
      currency={currency}
      canRemoveCustomTableRecords={canRemoveCustomTableRecords}
      onClose={onClose}
    />
  )
}
